import { useEffect } from 'react';
import { useTheme } from '@/core/contexts/ThemeContext';
import preferenceService from '@/services/preferenceService';

/**
 * Hook to sync investor preference view_mode with theme context
 * This ensures the theme automatically matches user preferences
 */
export const usePreferenceThemeSync = () => {
  const { setThemeMode } = useTheme();

  useEffect(() => {
    // Check if this is a fresh login vs session continuation
    const isSessionContinuation = sessionStorage.getItem('theme_session_active');
    
    // Only sync preferences on fresh login, not during session refreshes
    if (!isSessionContinuation && preferenceService.isReady()) {
      const viewMode = preferenceService.getViewMode();
      console.log('🎨 Fresh login: Syncing theme with preferences view_mode:', viewMode);
      setThemeMode(viewMode);
      
      // Mark session as active so subsequent refreshes don't override user changes
      sessionStorage.setItem('theme_session_active', 'true');
    } else if (isSessionContinuation) {
      console.log('🎨 Session continuation: Keeping current theme mode (respecting user choices)');
    }
  }, [setThemeMode]);

  // Return function to manually sync (useful after preferences update)
  const syncThemeWithPreferences = () => {
    if (preferenceService.isReady()) {
      const viewMode = preferenceService.getViewMode();
      console.log('🎨 Manually syncing theme with preferences view_mode:', viewMode);
      setThemeMode(viewMode);
    }
  };

  return { syncThemeWithPreferences };
};

export default usePreferenceThemeSync; 